var exports = {
  "iE": "xaee3c4fa--90b535--wrapper",
  "xA": "xaee3c4fa--90b535--likes-wrapper",
  "WC": "xaee3c4fa--90b535--like-wrapper",
  "i9": "xaee3c4fa--90b535--_clickable",
  "Pi": "xaee3c4fa--90b535--_liked",
  "Xg": "xaee3c4fa--90b535--_disliked",
};

module.exports = exports;
